import axios from 'axios'
import { ElMessage } from 'element-plus'
const baseURL = import.meta.env.VITE_API_BASE_URL

const request = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  },
  timeout: 600000 //3min
})

request.interceptors.request.use((config) => {
  // 在这里可以修改配置对象，比如添加自定义header
  return config
})

request.interceptors.response.use(
  (response) => {
    // 在这里可以对响应数据做一些处理
	if (response.data && response.data.code === 0) {
		return response.data
	}
	if (response.config.showToast) {
        ElMessage.error((response.data.message || response.data.detail) || '请求出错，请检查日志')
    }
	return Promise.reject(response.data)
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      // 请求已发出，服务器返回状态码不在 2xx 范围内
      if (error.config.showToast) {
        ElMessage.error((error.response.data.message || error.response.data.detail) || '请求出错，请检查日志')
      }
      return Promise.reject(error.response.data)
    } else {
		if (!axios.isCancel(error) && error.config.showToast) {
			ElMessage.error(error.message || '请求出错，请检查日志')
		  }
		return Promise.reject()
	}
  }
)
export default request
